import React from 'react';
import { useLocation } from 'react-router-dom';
declare global {
  interface Window { analytics: any; }
}

// custom hook for Segment to detect the page view event change
export function useLogPageEvent() {
  const pageLocation = useLocation();
  React.useEffect(() => {
    window.analytics.page(pageLocation.pathname, {
      userId: localStorage.ajs_user_id,
      userTraits: localStorage.ajs_user_traits,
    })}, [pageLocation]);
}